__turbopack_context__.v({
  "dropdown_btn": "PCgvDa_dropdown_btn",
  "text_content": "PCgvDa_text_content",
});
